
    import {Component, Vue} from 'vue-property-decorator'
    import {Action, Getter} from "vuex-class";
    import {
        AccountInfoDto,
        GetPreReturnOrderParamsDto,
        getPreRtnOrderInfo,
        PreRtnOrderInfoDto,
        submitReturnOrder
    } from "@/api/shopOrder";
    import {AppendixFileDto} from "@/api/commonConfig";
    import AppendixDialog from "@/views/orderManage/template/AppendixDialog.vue";
    import AppendixName from "@/components/AppendixName/index.vue";

    @Component({
        name: 'SubmitReturnOrder',
        components: { AppendixDialog, AppendixName }
    })
    export default class SubmitReturnOrder extends Vue {
        @Getter companyId!: string
        @Getter preReturnOrderParams!: GetPreReturnOrderParamsDto
        @Action setReturnOrderDtlList!: (val: PreRtnOrderInfoDto) => void;

        labelWidth = 100
        returnManBank = ''
        receiveManBankNo = ''
        returnMan = ''
        remark = ''
        orderFileList:AppendixFileDto[]=[] // 附件列表
        // orderFileUrl = ''
        // orderFileName = ''
        // orderFileSize = ''
        returnMoneyInput = null
        appendix = ''
        orderInfo: PreRtnOrderInfoDto = {}

        mounted () {
            // 注册事件
            // this.getAccountInfo()
        }

        created() {
            console.log(this.preReturnOrderParams)
            this.getInfo()
        }

        getInfo () {
            getPreRtnOrderInfo(this.preReturnOrderParams).then(res => {
                this.orderInfo = res.data
                this.returnMoneyInput = this.orderInfo.orderMoney
            })
        }

        /* 套餐清单 */
        toMerchBill () {
            this.setReturnOrderDtlList(this.orderInfo)
            this.$router.push('/returnMerchBill')
        }

        /* 显示上传附件弹窗 */
        showUploadFunc() {
            ;(this.$refs.appendixDialog as any).show({
                orderFile:this.orderFileList,
                fileType: '6',
            })
        }

        /* 获取上传附件信息 */
        getUploadInfo (data: AppendixFileDto[]) {
          this.orderFileList = data
        }

        /**
         * 调用原生方法切换银行账户
         */
        chooseAccountInfo() {
            const data = {
                customerId: this.orderInfo.customerId,
                isShowTemporary: false, // 是否展示临时账户信息 传false就是不展示，true就是展示
                title: '选择退款账户'
            }
            this.$bridge.callHandler('enterSelectAccountInfo', {data}, (res) => {
                const data = !res ? {} : JSON.parse(res)
                this.returnMan = data.accountName
                this.returnManBank = data.accountBank
                this.receiveManBankNo = data.accountId
            })
        }

        submitOrder () {
            if(this.receiveManBankNo === '') {
                return this.$toast('请先选择退款账户')
            }

            /* 退款金额初始默认值为：订单金额 */
            const data = {
                orderId: this.preReturnOrderParams.orderId,
                companyId: this.orderInfo.companyId, // 卖方
                customerId: this.orderInfo.customerId, // 买方
                // returnMoney: this.orderInfo.orderMoney,
                returnOrderAmount: this.orderInfo.packageTotalQuantity,
                returnMan: this.returnMan,
                returnManBank: this.returnManBank,
                receiveManBankNo: this.receiveManBankNo,
                orderFileList:this.orderFileList,
                orderRemark: this.remark,
                currRouteId: this.preReturnOrderParams.currRouteId,
                returnMoneySum: this.returnMoneyInput,
                /* 忘记是哪个bug单的数据返回的参数是orderDtlList，注意一下，设计文档是returnOrderDtlList */
                returnOrderDtl: this.orderInfo.returnOrderDtlList.map(item => {
                    return {
                        orderDtlId: item.orderDtlId,
                        returnAmount: item.returnAmount,
                        returnMoney: item.orderMoney
                    }
                })
            }
            submitReturnOrder(data).then((res) => {
                if (res.code === '000000') {
                   this.$router.replace({
                       path: '/submitReturnSuccess',
                       query: {
                           returnOrderId: res.data.returnOrderId,
                           returnMoneySum: res.data.returnMoneySum,
                           currRouteId: res.data.currRouteId,
                       }
                   })
                } else if (res.code === '000002') {
                    if (res.data.rejectType === 'InvalidOrder') {
                        this.$dialog.alert({
                            message: '该订货单不可退货，请重新选择'
                        }).then(() => {
                            this.getInfo()
                        })
                    } else if (res.data.rejectType === 'Expired') {
                        this.$dialog.alert({
                            message: '该订货单不可退货，请重新选择'
                        }).then(() => {
                            this.$router.back()
                        })
                    } else if (res.data.rejectType === 'OutOfRange') {
                        this.$dialog.alert({
                            message: '退货数量不能大于剩余可退货数量'
                        }).then(() => {
                            this.getInfo()
                        })
                    }
                }
            }).catch(() => {})
        }

        /**
         * 格式化金额 仅可录入数字，最少为0.00，最大为99999999.99,格式化去掉数字前面的0
         * @param value
         */
        formatterMoney(value) {
            value = Number(value) > 99999999.99 ? '99999999.99' : value
            return value.replace(/[^0-9.]/g,'').replace(/^(\\-)*(\d+)\.(\d\d).*$/,'$1$2.$3').replace(/0*(\d+)/,'$1')
        }

        /**
         * 失去焦点时，格式化数值为0
         */
        returnMoneyInputBlur() {
            if(!this.returnMoneyInput) {
                this.returnMoneyInput = 0
            }
        }
    }
